export const Success = ({ ...props }) => (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#C3DFD1"/>
<path d="M27.5 14.5859L17.1875 25.4193L12.5 20.495" stroke="#222222" stroke-linejoin="round"/>
</svg>
)